/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NumberRangeFilter
 */
export interface NumberRangeFilter {
    /**
     * Optional lower numeric value.
     * @type {number}
     * @memberof NumberRangeFilter
     */
    startAt?: number;
    /**
     * Optional upper numeric value.
     * @type {number}
     * @memberof NumberRangeFilter
     */
    endAt?: number;
}

/**
 * Check if a given object implements the NumberRangeFilter interface.
 */
export function instanceOfNumberRangeFilter(value: object): value is NumberRangeFilter {
    return true;
}

export function NumberRangeFilterFromJSON(json: any): NumberRangeFilter {
    return NumberRangeFilterFromJSONTyped(json, false);
}

export function NumberRangeFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): NumberRangeFilter {
    if (json == null) {
        return json;
    }
    return {
        
        'startAt': json['startAt'] == null ? undefined : json['startAt'],
        'endAt': json['endAt'] == null ? undefined : json['endAt'],
    };
}

export function NumberRangeFilterToJSON(json: any): NumberRangeFilter {
    return NumberRangeFilterToJSONTyped(json, false);
}

export function NumberRangeFilterToJSONTyped(value?: NumberRangeFilter | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'startAt': value['startAt'],
        'endAt': value['endAt'],
    };
}

